import React from 'react';
import PropTypes from 'prop-types';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import { IconButton } from '@material-ui/core';

const FullSizeButton = ({ onClick, color = 'primary', className }) => (
  <IconButton
    aria-label='add'
    onClick={onClick}
    color={color}
    className={className}
  >
    <ZoomOutMapIcon />
  </IconButton>
)

FullSizeButton.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  className: PropTypes.string
}
export default FullSizeButton;